import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IModule} from "angular";
import _ from "lodash";

require('./aktiverTotpDialog.scss');

export class AktiverTotpDialog {
    static regNavn = "aktiverTotpDialog";

    static registrerDialog(angular: IModule) {
        angular
            .service(AktiverTotpDialog.regNavn, AktiverTotpDialog.forInjisering())
            .controller(AktiverTotpDialogKontroller.regNavn, AktiverTotpDialogKontroller.forInjisering())
    }

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            AktiverTotpDialog
        ]
    }

    constructor(private $mdDialog: angular.material.IDialogService) {
    }

    private dialogKonfigurasjon = {
        template: require('./aktiverTotpDialog.html'),
        controller: AktiverTotpDialogKontroller.regNavn,
        controllerAs: '$ctrl',
        bindToController: true
    };

    visAktiverTotpDialog(vedLukkDialog:Function) {
        this.$mdDialog.show(_.defaults({}, this.dialogKonfigurasjon, {
            locals: {vedLukkDialog:vedLukkDialog}
        }));
    }
}

export class AktiverTotpDialogKontroller {
    static regNavn = "aktiverTotpDialogKontroller";

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            AktiverTotpDialogKontroller
        ]
    }

    constructor(private $mdDialog: angular.material.IDialogService) {
    }

    vedLukkDialog: Function; //satt via locals.vedLukkDialog i dialogKonfigurasjon

    lukk() {
        this.$mdDialog.hide();
        this.vedLukkDialog();
    }
}
